module.exports = __webpack_public_path__ + "img/ry1.6a945045.jpg";